var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', {
    staticClass: "accessories-product-card"
  }, [_c('LazyHydrate', {
    attrs: {
      "when-visible": ""
    }
  }, [_c('div', {
    staticClass: "accessories-product-card__wrapper"
  }, [_c('div', {
    staticClass: "accessories-product-card__top-wrapper"
  }, [_c('nuxt-link', {
    attrs: {
      "to": _vm.product.path || '#'
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.emit('product-select');
      }
    }
  }, [_c('LazyImg', {
    staticClass: "accessories-product-card__photo",
    attrs: {
      "img": _vm.product.thumbnail.x1,
      "srcset": _vm.product.thumbnail.x2,
      "alt": _vm.product.name,
      "disable": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "accessories-product-card__text-wrapper"
  }, [_vm.product.price && _vm.product.price.common ? _c('div', {
    staticClass: "accessories-product-card__price-wrap"
  }, [_c('div', {
    staticClass: "accessories-product-card__price"
  }, [_c('TSPrice', {
    attrs: {
      "price": _vm.product.price
    }
  })], 1), _vm._v(" "), _vm.product.price && _vm.product.price.bonus > 10 ? _c('div', {
    staticClass: "accessories-product-card__bonus-wrap"
  }, [_c('TSBonusCount', {
    attrs: {
      "size": "x-small",
      "count": _vm.product.price.bonus,
      "description": true
    }
  }), _vm._v(" "), _vm.product.price.discount ? _c('ProductDiscountMarker', {
    attrs: {
      "price": _vm.product.price.discount.value,
      "discount": _vm.product.price.common.value
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accessories-product-card__title p"
  }, [_c('nuxt-link', {
    staticClass: "link link_wu",
    attrs: {
      "to": _vm.product.path || '#',
      "title": _vm.product.name
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.emit('product-select');
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.product.name) + "\n          ")])], 1), _vm._v(" "), _c('ActionCart', {
    attrs: {
      "id": _vm.product.id,
      "product": _vm.product,
      "price": _vm.product.price && _vm.product.price.common.value,
      "source": _vm.source
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$product$status;

        var add = _ref.add,
            increaseAmount = _ref.increaseAmount,
            decreaseAmount = _ref.decreaseAmount,
            quantity = _ref.quantity,
            active = _ref.active,
            loading = _ref.loading;
        return [_c('div', {
          staticClass: "accessories-product-card__button"
        }, [_c('div', {
          staticClass: "accessories-product-card__button-row"
        }, [((_vm$product$status = _vm.product.status) === null || _vm$product$status === void 0 ? void 0 : _vm$product$status.code) === 'NOT_AVAILABLE' ? _c('div', {
          staticClass: "accessories-product-card__button-disabled"
        }, [_vm._v("\n                Распродано\n              ")]) : _c('div', {
          staticClass: "accessories-product-card__button-wrap",
          class: [{
            'accessories-product-card__button-wrap_active': active
          }],
          attrs: {
            "data-e2e": "add-to-basket"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              active ? null : (add({
                quantity: 1,
                product: _vm.product
              }), _vm.emit('add-product'));
            }
          }
        }, [active ? _c('TSCounter', {
          attrs: {
            "quantity": quantity,
            "max": 999,
            "loading": loading
          },
          on: {
            "decrease": function ($event) {
              return decreaseAmount({
                quantity: $event
              });
            },
            "increase": function ($event) {
              return increaseAmount({
                quantity: $event
              });
            }
          }
        }) : _c('div', {
          staticClass: "accessories-product-card__button-text"
        }, [_vm._v("\n                  В корзину\n                ")])], 1)])])];
      }
    }])
  })], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }